import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import SusyAvatar, { SuSyAvatarSizes } from '../susyAvatar/SusyAvatar';
import { User } from '../../../store/types';

import './UserInfoGroup.css';
import { UserRoles } from '../../../utils/utils';
import {
    getLocalizedUserRoleName,
    IUserRoleLocalization,
} from '../../../utils/users';

interface IUserInfoGroupProps {
    user: User;
    avatarSize?: SuSyAvatarSizes;
    showUserRole?: boolean;
    appendUserOrganizatinToTheUserRole?: boolean;
}

const NO_DATA = '-';

const getUserRoleName = (
    user: User,
    localization: IUserRoleLocalization
): string => {
    if (!user.userRole.key) {
        return NO_DATA;
    }

    const localizedUserRoleName = getLocalizedUserRoleName(
        user.userRole,
        localization
    );

    if (!localizedUserRoleName) {
        return NO_DATA;
    }

    if (
        user.userRole.name === UserRoles.supervisor &&
        user.isExternalSupervisor
    ) {
        return `${localizedUserRoleName} | ${localization.external}`;
    }

    return localizedUserRoleName;
};

const UserInfoGroup = ({
    user,
    avatarSize = SuSyAvatarSizes.MD,
    showUserRole = true,
    appendUserOrganizatinToTheUserRole = false,
}: IUserInfoGroupProps) => {
    const localization = useSelector(
        (state: RootState) =>
            state.localization.localizationStrings.susy.userRoles
    );

    const generalAppSettings = useSelector((state: RootState) => {
        return state.generalAppSettings;
    });

    return (
        <div className='user-info-group flex-fill'>
            <div className='d-flex align-items-center'>
                <SusyAvatar
                    size={avatarSize}
                    profilePictureId={user?.profilePictureId}
                />

                <div className='user-name-and-role'>
                    <div className='user-name'>
                        {user?.firstName} {user?.lastName}
                    </div>
                    {showUserRole && (
                        <div className='user-role'>
                            {getUserRoleName(user, {
                                Admin: localization.Admin,
                                Supervisor: localization.Supervisor,
                                User: localization.User,
                                external: localization.external,
                            })}
                            {appendUserOrganizatinToTheUserRole &&
                                ` ${localization.at} ${generalAppSettings.organizationName}`}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default UserInfoGroup;
